import React, { useState, useEffect, useCallback } from 'react';
import { soloVideos, bandVideos } from './data/videos';
import './VideoPage.css';

function Lightbox({ video, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!video) return null;
  return (
    <div className="lightbox" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="lightbox-inner">
        <button className="lightbox-close" onClick={onClose}>&times;</button>
        <div className="lightbox-video">
          <iframe
            src={`https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0&modestbranding=1`}
            title={video.name}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <p className="lightbox-title">{video.name}</p>
      </div>
    </div>
  );
}

function VideoCard({ video, category, onClick }) {
  return (
    <div className="video-card" onClick={() => onClick(video)} role="button" tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick(video)}>
      <div className="video-thumb">
        <img
          src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
          alt={video.name}
          loading="lazy"
        />
        <div className="play-overlay">
          <div className="play-icon" />
        </div>
      </div>
      <div className="video-label">{video.name}{category === 'band' ? ' (Band)' : ''}</div>
    </div>
  );
}

function VideoPage() {
  const [filter, setFilter] = useState('all');
  const [activeVideo, setActiveVideo] = useState(null);

  const openVideo = useCallback((video) => setActiveVideo(video), []);
  const closeVideo = useCallback(() => setActiveVideo(null), []);

  const allVideos = [
    ...soloVideos.map(v => ({ ...v, category: 'solo' })),
    ...bandVideos.map(v => ({ ...v, category: 'band' })),
  ];
  const filtered = filter === 'all' ? allVideos : allVideos.filter(v => v.category === filter);

  return (
    <>
      <section className="page-section video-page">
        <div className="section-header">
          <p className="section-eyebrow">Watch</p>
          <h2 className="section-title">Video Gallery</h2>
          <div className="gold-rule" />
        </div>

        <div className="tab-group">
          {['all', 'solo', 'band'].map(f => (
            <button
              key={f}
              className={`tab-btn${filter === f ? ' active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>

        <div className="video-grid">
          {filtered.map(v => (
            <VideoCard key={v.id + v.category} video={v} category={v.category} onClick={openVideo} />
          ))}
        </div>
      </section>

      {activeVideo && <Lightbox video={activeVideo} onClose={closeVideo} />}
    </>
  );
}

export default VideoPage;
